export default function getTaxTypes(tax) {
  return tax
    .map(tax => tax.name)
    .filter((v, i, a) => a.indexOf(v) === i)
}
